export default "__VITE_ASSET__04sskb4v__"